import type { IRequestGetOne } from '../../interfaces/requestGetOne';
import { RequestStatus } from '../../../../common/enums/requestStatus';
import { ServiceType } from '../../../../common/enums/serviceType';
import { translateKey } from '../../../translate';
import { Button } from '../common';

interface IEditRequestButtonProps {
    editRequest: () => Promise<void>;
    request: IRequestGetOne;
}

export function EditRequestButton(props: IEditRequestButtonProps) {
    if (
        !props.request.authorization ||
        !props.request.authorization.canUpdateRequest ||
        props.request.status !== RequestStatus.draft
    ) {
        return null;
    }

    return (
        <Button
            automation="editRequest"
            color="secondary"
            large
            onClick={props.editRequest}
        >
            {translateKey('common.edit')} {getRequestTranslation(props.request.serviceType).toLowerCase()}
        </Button>
    );
}

function getRequestTranslation(serviceType: ServiceType) {
    let requestTranslation = '';

    switch (serviceType) {
        case ServiceType.consultation:
            requestTranslation = translateKey('request.consult');
            break;
        case ServiceType.referral:
        case ServiceType.referralSmall:
            requestTranslation = translateKey('serviceTypeEnum.referral');
            break;
        case ServiceType.contact:
            requestTranslation = translateKey('serviceTypeEnum.contact');
            break;
        case ServiceType.counseling:
            requestTranslation = translateKey('serviceTypeEnum.counseling');
            break;
        default:
            requestTranslation = translateKey('request.request');
            break;
    }

    return requestTranslation;
}
